import React, { useEffect, useState } from "react";
import { Button, Table, Select } from "antd";
import { useModel, useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '公司',
        dataIndex: 'orgName',
        align: 'left',
    },
    {
        title: '货位编码',
        dataIndex: 'shelfCode',
        align: 'left',
    },
    {
        title: '所属仓库',
        dataIndex: 'warehouseName',
    },
    {
        title: '所属区域',
        dataIndex: 'areaName',
    },
    {
        title: '所属货架',
        dataIndex: 'shelvesName',
    },
    {
        title: '备注',
        dataIndex: 'shelfDesc',
    },

];

export default function () {
    const [
        { positionList, areaList, pagePosition, positionSelectedRowKeys, shelveList, selectedWarehouse, selectedPosition, tabsKey },
        { setPositionDrawerVisible, setSelectedPosition, setPositionSelectedRowKeys, setPositionActionType, loadPosition }
    ] = useModel("warehouse")
    const [{ userInfo }] = useModel("global");
    useEffect(() => {
        loadPosition({ showMsg: false, data: { warehouseId: selectedWarehouse ? selectedWarehouse.id : '', orgId: userInfo.orgId, pageSize: 15, pageNum: 1 } });
    }, [tabsKey])
    const [areaValue, setAreaValue] = useState("")
    const [shelveValue, setShelveValue1] = useState("")
    const [params, setParams] = useState({})


    const onAdd = () => {
        setPositionDrawerVisible(true);
        setPositionActionType(CM_ACTION_TYPE.INSERT);
    }
    const onEdit = () => {
        setPositionDrawerVisible(true);
        setPositionActionType(CM_ACTION_TYPE.EDIT);
    }
    const _onChange = (value, option) => {
        setAreaValue(value)
        let data = {
            "warehouseId": selectedWarehouse.id,
            "orgId": "",
            "areaId": value,
            "shelvesId": shelveValue,
            pageSize: 15,
            pageNum: 1
        }
        setParams(data)
        loadPosition({ data })
    }
    const _onChange2 = (value, option) => {
        setShelveValue1(value)
        let data = {
            "warehouseId": selectedWarehouse.id,
            "orgId": "",
            "areaId": areaValue,
            "shelvesId": value,
            pageSize: 15,
            pageNum: 1

        }
        setParams(data)
        loadPosition({ data })
    }
    const onPageChange = (page, pageSize) => {

        let data = {
            "warehouseId": selectedWarehouse.id,
            pageNum: page,
            pageSize: pageSize
        }
        loadPosition({ showMsg: false, data });
    }

    return (
        <>
            <div style={{ margin: "0 0 8px" }}>
                <Select
                    showSearch
                    allowClear={true}
                    style={{ width: "100px" }}
                    placeholder="所属区域"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={areaList.map(el => ({ key: el.id, label: el.areaName, value: el.id }))}
                    onChange={_onChange}
                />
                <Select
                    showSearch
                    allowClear={true}
                    style={{ width: "100px", marginLeft: "16px" }}
                    placeholder="所属货架"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={shelveList.map(el => ({ key: el.id, label: el.shelvesName, value: el.id }))}
                    onChange={_onChange2}
                />
                <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_SHELF_AD}>
                    <Button className="margin-left-16" type="primary" onClick={onAdd}>新增</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_SHELF_ED}>
                    <Button className="margin-left-16" disabled={!!!selectedPosition} onClick={onEdit}>编辑</Button>
                </YhAuth>
            </div>

            <Table
                columns={columns}
                dataSource={positionList}
                bordered
                pagination={{
                    hideOnSinglePage: true,
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: onPageChange,
                    total: pagePosition.total,
                    current: pagePosition.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedPosition && selectedPosition.key === record.key) {
                                setSelectedPosition(null);
                                setPositionSelectedRowKeys([]);
                            } else {
                                setSelectedPosition(record);
                                setPositionSelectedRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                        setSelectedPosition(selectedRows[0]);
                        setPositionSelectedRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled',
                        name: record.name,
                    }),
                    selectedRowKeys: positionSelectedRowKeys,
                }}
                scroll={{ x: 'max-content' }}
            />
        </>
    )
}